//@flow
import React from "react";
import { connect } from "react-redux";

import { Translate } from "@quantum/i18n";

import {
  ID_PERIODO_JANELA,
  type Id,
  type MedidaSelecionada,
  type DatasSelecaoJanela,
  type EdicaoMedida,
} from "../../../../../../model";
import {
  type State,
  type ActionCreator,
  type ProcessadorPeriodo,
  getPeriodoUnicoSelecionado,
  obterDatasUteisSelecaoJanela,
  obterMesesSelecaoJanela,
  getSelecaoJanela,
  getTamanhoJanelaSelecionada,
  getQuantidadeJanelasSelecionada,
  getTipoJanelaSelecionada,
  getEdicaoMedida,
} from "../../../../../../state";

import { randomId } from "../../../../../../util";

import { useDatasSelecaoJanela } from "../../../../../remote";

import { remoteData } from "@quantum/remote-data";

import SelecaoTamanhoJanela from "./SelecaoTamanhoJanela";
import SelecaoQuantidadeJanelas from "./SelecaoQuantidadeJanelas";
import SelecaoTipoJanela from "./SelecaoTipoJanela";

type Props = {
  exibir: boolean,
  obterDatasUteisSelecaoJanela: () => ActionCreator,
  obterMesesSelecaoJanela: () => ActionCreator,
  selecaoJanela: Object,
  tamanhoJanelaSelecionada: number,
  quantidadeJanelasSelecionada: number,
  dataBaseDefault: string,
  tipoJanelaSelecionada: Id,
};

const exibirSelecaoJanela: (state: State) => boolean = (state: State) =>
  getPeriodoUnicoSelecionado(state) === ID_PERIODO_JANELA;

function SelecaoJanela({
  exibir,
  obterDatasUteisSelecaoJanela,
  obterMesesSelecaoJanela,
  selecaoJanela,
  tamanhoJanelaSelecionada,
  quantidadeJanelasSelecionada,
  tipoJanelaSelecionada,
}: Props) {
  useDatasSelecaoJanela({
    properties: { selecaoJanela, tipoJanelaSelecionada },
    fetch: exibir,
  });

  if (!exibir) {
    return null;
  }

  return (
    <div className="ConfiguracaoMedida">
      <h3 className="ConfiguracaoMedida__group-title--big">
        <Translate>maiusculas.janela</Translate>
      </h3>
      <div className="ConfiguracaoMedida__group--grey">
        <div className="ConfiguracaoMedida__box">
          <SelecaoTipoJanela />
        </div>

        <div className="ConfiguracaoMedida__box">
          <SelecaoTamanhoJanela />
        </div>

        <div className="ConfiguracaoMedida__box">
          <SelecaoQuantidadeJanelas />
        </div>
      </div>
    </div>
  );
}

export const processarPeriodoJanela: ProcessadorPeriodo = (
  periodo: Id,
  state: State,
  medidasSelecionadas: Array<MedidaSelecionada>
) => {
  const edicaoMedida: EdicaoMedida = getEdicaoMedida(state);
  const tipoJanelaSelecionada: ?Id = getTipoJanelaSelecionada(state);
  const selecaoJanela = getSelecaoJanela(state);
  const janelasSelecaoJanela: Array<DatasSelecaoJanela> = remoteData(
    "datasSelecaoJanela",
    { selecaoJanela, tipoJanelaSelecionada },
    state
  );

  if (janelasSelecaoJanela) {
    return janelasSelecaoJanela
      .sort(
        (janela1, janela2) => janela1.numeroDaJanela - janela2.numeroDaJanela
      )
      .flatMap(janela => {
        const idGrupo: Id = randomId();
        return medidasSelecionadas.map(medidaSelecionada => ({
          ...medidaSelecionada,
          idGrupoMedidasSelecionadas: idGrupo,
          periodo,
          periodicidade: edicaoMedida.periodicidade,
          dataInicial: janela.dataInicial,
          dataFinal: janela.dataFinal,
          numeroJanela: janela.numeroDaJanela,
          tamanhoJanela: edicaoMedida.tamanhoJanela,
          quantidadeJanelas: edicaoMedida.quantidadeJanelas,
          tipoJanela: edicaoMedida.tipoJanela,
        }));
      });
  }

  return [];
};

export default connect(
  (state: State) => ({
    exibir: exibirSelecaoJanela(state),
    tamanhoJanelaSelecionada: getTamanhoJanelaSelecionada(state),
    quantidadeJanelasSelecionada: getQuantidadeJanelasSelecionada(state),
    tipoJanelaSelecionada: getTipoJanelaSelecionada(state),
    selecaoJanela: getSelecaoJanela(state),
  }),
  { obterDatasUteisSelecaoJanela, obterMesesSelecaoJanela }
)(SelecaoJanela);
